import { EVENT_STATUS, STREAM_STATUS, FINAL_EVENT_STATUS, EVENT_TYPE } from '../../constants';
import { PrepareSimuliveUrl } from '../../utils';

export const getEventStatus = (eventStatus, streamStatus) => {
  switch (eventStatus) {
    case EVENT_STATUS.UNKNOWN:
    case EVENT_STATUS.BOX_WARMING:
    case EVENT_STATUS.BOX_WARMED:
      return FINAL_EVENT_STATUS.NOT_STARTED;
    case EVENT_STATUS.EVENT_RUNNING:
      switch (streamStatus) {
        case STREAM_STATUS.NOT_STARTED:
        case STREAM_STATUS.UNKNOWN:
          return FINAL_EVENT_STATUS.NOT_STARTED;
        case STREAM_STATUS.PAUSING:
        case STREAM_STATUS.PAUSED:
          return FINAL_EVENT_STATUS.PAUSED;
        case STREAM_STATUS.ENDED:
          return FINAL_EVENT_STATUS.ENDED;
        case STREAM_STATUS.STARTING:
          return FINAL_EVENT_STATUS.STARTING;
        case STREAM_STATUS.RUNNING:
          return FINAL_EVENT_STATUS.RUNNING;
        default:
          break;
      }
      break;
    case EVENT_STATUS.EVENT_ENDING:
    case EVENT_STATUS.EVENT_ENDED:
      return FINAL_EVENT_STATUS.ENDED;
    default:
      break;
  }
};

export const getEventType = (eventType, recording) => {
  let type = eventType;
  if (eventType === EVENT_TYPE.WEB_STUDIO || eventType === EVENT_TYPE.SIMULIVE || eventType === EVENT_TYPE.EPG)
    type = EVENT_TYPE.HLS_LIVE;
  if (recording) return Math.abs(type) * -1;
  return type;
};

export const getAppView = () => {};

export const preparePlayListWelcomeData = (data) => {
  let pData = {
    head: data.i,
    hls: PrepareSimuliveUrl(data?.s?.cdn?.[0], data?.s?.hls),
    seek: data.d, // seek position for current playing media in ms
    id: data.s.id,
    dur: data.s.dur,
    start: data.st || 0, // media start time in ms
    end: data.et || 0, // media end time in ms
    studio: data.s.studio,
  };
  return pData;
};
